interface BadgeProps {
    label: string;
    variant?: 'primary' | 'success' | 'warning' | 'danger';
  }
  
  const ExtendedBadge = ({ label, variant = 'primary' }: BadgeProps) => {
    let badgeClasses = 'px-2 py-1 rounded-full text-sm font-medium flex items-center max-w-max';
  
    switch (variant) {
      case 'primary':
        badgeClasses += ' bg-blue-100 text-blue-800';
        break;
      case 'success':
        badgeClasses += ' bg-green-100 text-green-800';
        break;
      case 'warning':
        badgeClasses += ' bg-yellow-100 text-yellow-800';
        break;
      case 'danger':
        badgeClasses += ' bg-red-100 text-red-800';
        break;
    }
  
    return (
      <span className={badgeClasses}>
            <span className="w-2 h-2  rounded-full mr-2" style={{ backgroundColor: variant === 'primary' ? '#3b82f6' : variant === 'success' ? '#22c55e' : variant === 'warning' ? '#f59e0b' : '#ef4444' }} />
            <span className='text-xs'>  
              {label}
            </span>
      </span>
    );
  };
  
  export default ExtendedBadge;